import { useEffect, useState } from "react";
import { PageHeaderUi, ButtonUi, NewBtn } from "../../../../ui";
import { TipoButtonConstants } from "../../../../../types/typesConstants";
import { Col, Row, Space } from "antd";
import { ProgramacionTejidoTable } from "./ProgramacionTejidoTable";
import { useDispatch, useSelector } from "react-redux";
import {
  get_excel_programacionestejido_by_filters,
  programacionTejidoClearActive,
  programacionTejidoStartLoad,
} from "../../../../../actions/produccion";
import { ProgramacionTejidoScreen } from "./ProgramacionTejidoScreen";
import { ProgramacionTejidoSearchTable } from "./ProgramacionTejidoSearchTable";
import { FileExcelOutlined } from "@ant-design/icons";
import { SaldosProgramacionTejidoScreen } from "./SaldosProgramacionTejidoScreen";
import dayjs from "dayjs";
import { parseDateFormatBackEnd } from "../../../../../helpers/utils";

const ProgramacionTejidoListScreen = ({
  handleOpenForm,
  handleOpenSaldosForm,
}) => {
  const {
    programacionesTejido,
    filterFormSearchProgramacionTejido,
    loading,
    paginator,
  } = useSelector((state) => state.produccion);
  const handleReporteExcel = () => {
    if (!!filterFormSearchProgramacionTejido)
      get_excel_programacionestejido_by_filters(
        filterFormSearchProgramacionTejido
      );
    else get_excel_programacionestejido_by_filters();
  };
  return (
    <PageHeaderUi
      title="Programación de Tejido"
      subTitle="Listado"
      extra={[
        <Space key="opts" wrap>
          <ButtonUi
            key="rptexcel"
            typeUi={TipoButtonConstants.CustomButton}
            onClick={handleReporteExcel}
            icon={<FileExcelOutlined />}
            text="Reporte"
            type="success"
          />
          <NewBtn key="nuevo" onClick={handleOpenForm} />
        </Space>,
      ]}
    >
      <div style={{ overflow: "hidden" }}>
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col className="gutter-row" span={24}>
            <ProgramacionTejidoSearchTable />
          </Col>
        </Row>
        <Row>
          <Col sm={32} md={32} xl={24}>
            <ProgramacionTejidoTable
              data={programacionesTejido}
              loading={loading}
              paginator={paginator}
              handleOpenForm={handleOpenForm}
              handleOpenSaldosForm={handleOpenSaldosForm}
            />
          </Col>
        </Row>
      </div>
    </PageHeaderUi>
  );
};

export const ProgramacionTejidoList = () => {
  const [openSaldosForm, setOpenSaldosForm] = useState(false);
  const [openForm, setOpenForm] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      programacionTejidoStartLoad({
        fechainicio_after: parseDateFormatBackEnd(dayjs()),
        fechainicio_before: parseDateFormatBackEnd(dayjs()),
      })
    );
  }, []);
  const handleOpenForm = () => setOpenForm(true);
  const handleCloseForm = () => {
    dispatch(programacionTejidoClearActive());
    setOpenForm(false);
  };
  const handleOpenSaldosForm = () => setOpenSaldosForm(true);
  const handleCloseSaldosForm = () => setOpenSaldosForm(false);
  if (openForm) {
    return <ProgramacionTejidoScreen handleCloseForm={handleCloseForm} />;
  } else if (openSaldosForm) {
    return (
      <SaldosProgramacionTejidoScreen
        handleCloseSaldosForm={handleCloseSaldosForm}
      />
    );
  } else {
    return (
      <ProgramacionTejidoListScreen
        handleOpenForm={handleOpenForm}
        handleOpenSaldosForm={handleOpenSaldosForm}
      />
    );
  }
};
export default ProgramacionTejidoList;
